import Fetch from '../../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IRetailerOrdersResponse } from './IRetailerOrdersResponse';

export const getRetailerOrders = () : AxiosPromise<IRetailerOrdersResponse> => {
  return Fetch().then(axios => axios.get('orders/retailer'));
};
